/**
 * Normaliza valores de `import.meta.env` (Vercel / pegar desde Windows suelen dejar `\r` o espacios).
 */
export function viteEnvTrim(value: unknown): string {
  if (value == null) return '';
  return String(value).replace(/\r/g, '').trim();
}
